/* eslint-disable no-unused-vars */
import httpService from '@/services/httpService'
import AttributeReport from '../../../features/reports/attribute/AttributeReport'

export const types = {
  ADD_INTEGRATIONS: 'ADD_INTEGRATIONS',
  ADD_INTEGRATION_DATA: 'ADD_INTEGRATION_DATA'
}
const state = {
  integrationsList: [],
  availableIntegrations: [],
  integrationData: {}
}

const mutations = {
  [types.ADD_INTEGRATIONS]: function (state, { integrations_list, available_integrations }) {
    state.integrationsList = integrations_list || []
    state.availableIntegrations = available_integrations || []
  },
  [types.ADD_INTEGRATION_DATA]: function (state, data) {
    state.integrationData = data || {}
  }
}

const actions = {
  getIntegrationsList: async function ({ commit }, { clientId }) {
    const response = await httpService.get(`/integrations/${clientId}`)
    if (!response || !response.data) {
      return
    }
    commit(types.ADD_INTEGRATIONS, response.data)
    return response.data
  },
  getIntegrationData: async function ({ commit }, { clientId, integrationName }) {
    const params = { integration_name: integrationName }
    const response = await httpService.get(`/integrations/get-integration-data/${clientId}`, { params })
    if (!response || !response.data) {
      return
    }
    commit(types.ADD_INTEGRATION_DATA, response.data)
    return response.data
  },
  deleteIntegration: function ({ commit, dispatch }, { clientId, integrationName }) {
    const params = { integration_name: integrationName }
    const response = httpService.delete(`/integrations/delete-integration/${clientId}`,
      { params, successMessage: 'Integration deleted successfully' })
    if (!response) {
      return
    }
    if (integrationName === 'cloudflare') {
      dispatch('rankZoneCommon/changeCloudflareEnabled', false, { root: true })
    } else if (integrationName === 'shopify') {
      dispatch('rankZoneCommon/changeShopifyEnabled', false, { root: true })
    }
    return response
  },
  multipleIntegrationAction: function ({ commit }, { clientId, successMessage, infoMessage, ...params }) {
    return httpService.patch(`/integrations/multiple-integration-action/${clientId}`,
      params,
      { successMessage, infoMessage })
  },
  changeIntegration: function ({ commit }, { clientId, integrationName, workspace, project, cloudflare_email, cloudflare_api_key, cloudflare_enabled, cloudflare_account_id, shopify_access_token }) {
    const params = { integration_name: integrationName, workspace, project, cloudflare_email, cloudflare_api_key, cloudflare_enabled, cloudflare_account_id, shopify_access_token }
    return httpService.patch(`/integrations/change-integration/${clientId}`,
      params,
      { successMessage: 'Integration changed successfully' })
  },
  createCloudflareIntegration: function ({ commit, dispatch }, { clientId, email, apiKey, accountId }) {
    const params = { email, apiKey, accountId }
    const response = httpService.post(`/integrations/create-cloudflare-integration/${clientId}`,
      params,
      { successMessage: 'Integration added successfully' })
    if (!response) {
      return
    }
    dispatch('rankZoneCommon/changeCloudflareEnabled', true, { root: true })
    return response
  },
  createShopifyIntegration: function ({ commit, dispatch }, { clientId, accessToken }) {
    const params = { accessToken }
    const response = httpService.post(`/integrations/create-shopify-integration/${clientId}`,
      params,
      { successMessage: 'Integration added successfully' })
    if (!response) {
      return
    }
    dispatch('rankZoneCommon/changeShopifyEnabled', true, { root: true })
    return response
  }
}

/**
 * Store manage data for Reports/Attribute Reports {@link AttributeReport}
 */
export default {
  namespaced: true,
  state,
  actions,
  mutations
}
